export function useSelectedTicker(dashboard, selectedSymbol) {
  const tickers = dashboard?.tickers || [];
  return tickers.find((tickerItem) => tickerItem.inst_id === selectedSymbol) || tickers[0];
}